import DialogContent from '@zenbusiness/zui/DialogContent';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const BoxContentStyled = styled(Stack)(({ theme }) => ({
  padding: '24px',
  border: `1px solid ${theme.palette.border.dark}`,
  borderRadius: '22px'
}));

export const FormControlLabelStyled = styled(FormControlLabel)(() => ({
  padding: '0px',
  width: 'fit-content'
}));

export const Wrapper = styled(Stack)(({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
}));

export const DialogContentStyled = styled(DialogContent)(() => ({
  padding: 0,
  '::-webkit-scrollbar': {
    display: 'none'
  },
  paddingBottom: '100px'
}));
